export default function penniesToDollars(pennies: number): string {
  if (typeof pennies !== "number") {
    throw new TypeError("pennies must be a number");
  }

  const dollars = pennies / 100;
  const formattedDollars = Math.abs(dollars).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (dollars < 0) {
    return `($${formattedDollars})`;
  }

  return `$${formattedDollars}`;
}
